import axios from 'axios'
import qs from 'qs'
import common from './common';
import {
    getStorage
} from './util'
axios.defaults.baseURL = common.apiBaseURL
//请求拦截器
axios.interceptors.request.use(config => {
    let accessToken = getStorage('access_token')
    let lang = getStorage('lang') || common.lang
    let time = (new Date()).getTime()
    let proxyCode = getStorage('proxy_code')
    if (accessToken) {
        if (config.url.indexOf('?') != -1) {
            config.url += '&access_token=' + accessToken + '&lang=' + lang + '&_format=json&time=' + time+'&proxyCode='+proxyCode
        } else {
            config.url += '?access_token=' + accessToken + '&lang=' + lang + '&_format=json&time=' + time+'&proxyCode='+proxyCode
        }
    } else {
        if (config.url.indexOf('?') != -1) {
            config.url += '&_format=json&lang=' + lang + '&time=' + time+'&proxyCode='+proxyCode
        } else {
            config.url += '?_format=json&lang=' + lang + '&time=' + time+'&proxyCode='+proxyCode
        }
    }
    return config
}, err => Promise.reject(err))
//响应拦截器
axios.interceptors.response.use(response => response.data, err => Promise.reject(err))
//封装get请求
export const $fetch = async (url, params = {}) => await axios.get(url, params)
//封装post 请求
export const $post = async (url, data = {}) => await axios.post(url, qs.stringify(data))
//封装put 请求
export const $put = async (url, data = {}) => await axios.put(url, qs.stringify(data))
//封装delete 请求
export const $del = async (url, params = {}) => await axios.delete(url, {
    data: qs.stringify(params)
})